import { Info, ShoppingCart, ArrowUUpLeft, Money, Truck, Storefront } from '@phosphor-icons/react'
import { canViewCharges } from '../../global_context/capabilities/chargeCapabilities'
import { canViewDeliveries } from '../../global_context/capabilities/deliveryCapabilities'
import { canViewOrders } from '../../global_context/capabilities/orderCapabilities'
import { canViewPosEffectiveness } from '../../global_context/capabilities/posCapabilities'
import { canViewRefunds } from '../../global_context/capabilities/refundCapabilities'
import { canViewReports } from '../../global_context/capabilities/reportCapabilities'

export const EFFECTIVENESS_REPORT_TAB_VALUES = {
  SUMMARY: 'summary',
  ORDERS: 'orders',
  REFUNDS: 'refunds',
  CHARGES: 'charges',
  DELIVERIES: 'deliveries',
  POS: 'pos'
}

export const EFFECTIVENESS_REPORT_TABS = [
  {
    value: 'summary',
    label: 'Resumen',
    endpoint: 'ubiqua_app',
    icon: Info,
    iconSize: 20,
    filled: false
  },
  {
    value: 'orders',
    label: 'Pedidos',
    endpoint: 'orders',
    icon: ShoppingCart,
    iconSize: 20,
    filled: false
  },
  {
    value: 'refunds',
    label: 'Devoluciones',
    endpoint: 'returns',
    icon: ArrowUUpLeft,
    iconSize: 20,
    filled: false
  },
  {
    value: 'charges',
    label: 'Cobros',
    endpoint: 'charges',
    icon: Money,
    iconSize: 20,
    filled: false
  },
  {
    value: 'deliveries',
    label: 'Entregas',
    endpoint: 'deliveries',
    icon: Truck,
    iconSize: 20,
    filled: false
  },
  {
    value: 'pos',
    label: 'Ejecución en punto de venta',
    endpoint: 'pos',
    icon: Storefront,
    iconSize: 20,
    filled: false
  }
]

export const getEffectivenessReportTab = (tabValue) =>
  EFFECTIVENESS_REPORT_TABS.find((tab) => tab.value === tabValue)

const EFFECTIVENESS_REPORT_TAB_ACCESS = {
  [EFFECTIVENESS_REPORT_TAB_VALUES.SUMMARY]: canViewReports,
  [EFFECTIVENESS_REPORT_TAB_VALUES.ORDERS]: canViewOrders,
  [EFFECTIVENESS_REPORT_TAB_VALUES.REFUNDS]: canViewRefunds,
  [EFFECTIVENESS_REPORT_TAB_VALUES.CHARGES]: canViewCharges,
  [EFFECTIVENESS_REPORT_TAB_VALUES.DELIVERIES]: canViewDeliveries,
  [EFFECTIVENESS_REPORT_TAB_VALUES.POS]: canViewPosEffectiveness
}

export const getVisibleEffectivenessReportTabs = () =>
  EFFECTIVENESS_REPORT_TABS.filter((tab) => {
    const canViewTab = EFFECTIVENESS_REPORT_TAB_ACCESS[tab.value]
    return typeof canViewTab === 'function' ? canViewTab() : true
  })
